import { callApi } from "@/api/api-core";

export const fetchSeatTypes = function(ownerHandlesFailure) {
    return callApi("POST", "v2/seattypes/list", {}, ownerHandlesFailure);
};
